import CampaignIcon from "assets/icons/mono/CampaignIcon";
import DashboardIcon from "assets/icons/mono/DashboardIcon";
import StarIcon from "assets/icons/mono/StarIcon";
import UserIcon from "assets/icons/mono/UserIcon";
import { PRIVILEGE } from "constants/privilege";
import { useFirebase } from "contexts/FirebaseAuthContext";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState } from "store";
import { query, collection, where, onSnapshot } from "firebase/firestore"
import MenuItemIcon from "assets/icons/mono/MenuItemIcon";
import CollabIcon from "assets/icons/mono/CollabIcon";
import ContentLibraryIcon from "assets/icons/mono/ContentLibraryIcon";
import ChatIcon from "assets/icons/mono/ChatIcon";
import WalletIcon from "assets/icons/mono/WalletIcon";
import BrandHubIcon from "assets/icons/mono/BrandHubIcon";
import SocialAccountsIcon from "assets/icons/mono/SocialAccountsIcon";
import TrackMediaIcon from "assets/icons/mono/TrackMediaIcon";
import CompetitionIcon from "assets/icons/mono/CompetitionIcon";
import CollectionIcon from "assets/icons/mono/CollectionIcon";
import SupportIcon from "assets/icons/mono/SupportIcon";
import { openMsg91Chat } from "utils/msg91Chat";

const Navdata = () => {

    const configurations = useSelector((state: RootState) => state.auth.configurations);

    const history = useNavigate();
    //state data
    const [isDashboard, setIsDashboard] = useState(false);
    const [isApps, setIsApps] = useState(false);
    const [isAuth, setIsAuth] = useState(false);
    const [isPages, setIsPages] = useState(false);
    const [isBaseUi, setIsBaseUi] = useState(false);
    const [isAdvanceUi, setIsAdvanceUi] = useState(false);
    const [isForms, setIsForms] = useState(false);
    const [isTables, setIsTables] = useState(false);
    const [isCharts, setIsCharts] = useState(false);
    const [isIcons, setIsIcons] = useState(false);
    const [isMaps, setIsMaps] = useState(false);
    const [isMultiLevel, setIsMultiLevel] = useState(false);

    const [collapsedMenuItems, setCollapsedMenuItems] = useState<string[]>(['collab-hub']);

    const [iscurrentState, setIscurrentState] = useState('Dashboard');

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");

                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        if (iscurrentState !== 'Apps') {
            setIsApps(false);
        }
        if (iscurrentState !== 'Auth') {
            setIsAuth(false);
        }
        if (iscurrentState !== 'Pages') {
            setIsPages(false);
        }
        if (iscurrentState !== 'BaseUi') {
            setIsBaseUi(false);
        }
        if (iscurrentState !== 'AdvanceUi') {
            setIsAdvanceUi(false);
        }
        if (iscurrentState !== 'Forms') {
            setIsForms(false);
        }
        if (iscurrentState !== 'Tables') {
            setIsTables(false);
        }
        if (iscurrentState !== 'Charts') {
            setIsCharts(false);
        }
        if (iscurrentState !== 'Icons') {
            setIsIcons(false);
        }
        if (iscurrentState !== 'Maps') {
            setIsMaps(false);
        }
        if (iscurrentState !== 'MuliLevel') {
            setIsMultiLevel(false);
        }
        if (iscurrentState === 'Widgets') {
            history("/widgets");
            document.body.classList.add('twocolumn-panel');
        }
    }, [
        history,
        iscurrentState,
        isDashboard,
        isApps,
        isAuth,
        isPages,
        isBaseUi,
        isAdvanceUi,
        isForms,
        isTables,
        isCharts,
        isIcons,
        isMaps,
        isMultiLevel
    ]);

    const privileges = useSelector((state: RootState) => state.auth.privileges);

    const hasPrivilege = (privilege: string) => {
        return privileges.includes(privilege);
    }

    const menuItems: any = [
        {
            label: "Menu",
            isHeader: true,
        },
        {
            id: "dashboard",
            label: "Dashboard",
            iconSVG: <DashboardIcon />,
            link: "/",
            stateVariables: isDashboard,
            click: function (e: any) {
                setIsDashboard(!isDashboard);
                setIscurrentState('Dashboard');
                updateIconSidebar(e);
            },
            hasPrivilege: true,
        },
        {
            id: "collab-hub",
            label: "Collab Hub",
            // icon: "bx bxs-megaphone",
            iconSVG: <MenuItemIcon />,
            stateVariables: !collapsedMenuItems.includes('collab-hub'),
            hasPrivilege: true,
            click: function (e: any) {
                e.preventDefault();
                if (collapsedMenuItems.includes('collab-hub')) {
                    setCollapsedMenuItems(collapsedMenuItems.filter((item) => item !== 'collab-hub'));
                } else {
                    setCollapsedMenuItems([...collapsedMenuItems, 'collab-hub']);
                }
                setIsDashboard(!isDashboard);
                setIscurrentState('collab-hub');
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: "campaigns",
                    label: "Campaigns",
                    icon: "bx bxs-megaphone",
                    iconSVG: <CampaignIcon />,
                    link: "/campaign",
                    stateVariables: isDashboard,
                    click: function (e: any) {
                        e.preventDefault();
                        setIsDashboard(!isDashboard);
                        setIscurrentState('Campaigns');
                        updateIconSidebar(e);
                    },
                    hasPrivilege: hasPrivilege(PRIVILEGE.CAMPAIGN.CAMPAIGN.SHOW),
                },
                {
                    id: "collaborations",
                    label: "Collaborations",
                    // icon: "ri-service-fill",
                    iconSVG: <CollabIcon />,
                    link: "/collaboration",
                    stateVariables: isDashboard,
                    click: function (e: any) {
                        e.preventDefault();
                        setIsDashboard(!isDashboard);
                        setIscurrentState('collaboration');
                        updateIconSidebar(e);
                    },
                    hasPrivilege: hasPrivilege(PRIVILEGE.CAMPAIGN.COLLABORATION.INDEX),
                },
                {
                    id: "content-library",
                    label: "Content Library",
                    icon: "ri-video-line",
                    iconSVG: <ContentLibraryIcon />,
                    link: "/content-library",
                    stateVariables: isDashboard,
                    click: function (e: any) {
                        setIsDashboard(!isDashboard);
                        setIscurrentState('content-library');
                        updateIconSidebar(e);
                    },
                    hasPrivilege: hasPrivilege(PRIVILEGE.CAMPAIGN.COLLABORATION.INDEX),
                },
                {
                    id: "chat",
                    label: "Chat",
                    link: "/chat",
                    iconSVG: <ChatIcon />,
                    stateVariables: isDashboard,
                    click: function (e: any) {
                        setIsDashboard(!isDashboard);
                        setIscurrentState('chat');
                        updateIconSidebar(e);
                    },
                    hasPrivilege: hasPrivilege(PRIVILEGE.CAMPAIGN.COLLABORATION.INDEX)
                },

                {
                    id: "wallet",
                    label: "Wallet",
                    link: "/wallet",
                    iconSVG: <WalletIcon />,
                    stateVariables: isDashboard,
                    click: function (e: any) {
                        setIsDashboard(!isDashboard);
                        setIscurrentState('Wallet');
                        updateIconSidebar(e);
                    },
                    hasPrivilege: hasPrivilege(PRIVILEGE.CAMPAIGN.COLLABORATION.INDEX)
                },
                {
                    id: "brands",
                    label: "Brands",
                    icon: "bx bx-buildings",
                    iconSVG: <StarIcon />,
                    link: "/brand",
                    stateVariables: isDashboard,
                    click: function (e: any) {
                        setIsDashboard(!isDashboard);
                        setIscurrentState('Brands');
                        updateIconSidebar(e);
                    },
                    hasPrivilege: true,
                },
                {
                    id: "creator-marketplace",
                    label: "Creator Marketplace",
                    icon: "mdi mdi-account-search-outline",
                    link: '/creator-marketplace',
                    stateVariables: isDashboard,
                    click: function (e: any) {
                        setIsDashboard(!isDashboard);
                        setIscurrentState('Social Accounts');
                        updateIconSidebar(e);
                    },
                    hasPrivilege: configurations?.agency_ig_creator_marketplace === 'y'
                },
                {
                    id: "creator-discovery",
                    label: "Creator Discovery",
                    icon: "mdi mdi-account-search",
                    link: '/creator-discovery',
                    stateVariables: isDashboard,
                    click: function (e: any) {
                        setIsDashboard(!isDashboard);
                        setIscurrentState('Social Accounts');
                        updateIconSidebar(e);
                    },
                    hasPrivilege: configurations?.agency_creator_discovery === 'y'
                },
            ]
        },
        {
            id: "brand-hub",
            label: "Brand Hub",
            // icon: "bx bxs-megaphone",
            iconSVG: <BrandHubIcon />,
            stateVariables: !collapsedMenuItems.includes('brand-hub'),
            hasPrivilege: true,
            click: function (e: any) {
                if (collapsedMenuItems.includes('brand-hub')) {
                    setCollapsedMenuItems(collapsedMenuItems.filter((item) => item !== 'brand-hub'));
                } else {
                    setCollapsedMenuItems([...collapsedMenuItems, 'brand-hub']);
                }
                setIsDashboard(!isDashboard);
                setIscurrentState('brand-hub');
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: "social-account",
                    label: "Social Accounts",
                    link: '/social-account',
                    iconSVG: <SocialAccountsIcon />,
                    stateVariables: isDashboard,
                    click: function (e: any) {
                        setIsDashboard(!isDashboard);
                        setIscurrentState('Social Accounts');
                        updateIconSidebar(e);
                    },
                    // hasPrivilege: configurations?.agency_social_connect === 'y'
                    hasPrivilege: true,
                },
                {
                    id: "track-media",
                    label: "Track media",
                    link: '/track-media',
                    iconSVG: <TrackMediaIcon />,
                    stateVariables: isDashboard,
                    click: function (e: any) {
                        setIsDashboard(!isDashboard);
                        setIscurrentState('Track Media');
                        updateIconSidebar(e);
                    },
                    hasPrivilege: true
                },
            ]
        },
        {
            id: "inspiration-hub",
            label: "Inspiration Hub",
            iconSVG: <MenuItemIcon />,
            stateVariables: !collapsedMenuItems.includes('inspiration-hub'),
            hasPrivilege: true,
            click: function (e: any) {
                if (collapsedMenuItems.includes('inspiration-hub')) {
                    setCollapsedMenuItems(collapsedMenuItems.filter((item) => item !== 'inspiration-hub'));
                } else {
                    setCollapsedMenuItems([...collapsedMenuItems, 'inspiration-hub']);
                }
                setIsDashboard(!isDashboard);
                setIscurrentState('inspiration-hub');
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: "competition",
                    label: "Competitors",
                    iconSVG: <CompetitionIcon />,
                    link: '/competitor',
                    stateVariables: isDashboard,
                    click: function (e: any) {
                        setIsDashboard(!isDashboard);
                        setIscurrentState('Competitors');
                        updateIconSidebar(e);
                    },
                    hasPrivilege: true
                },

            ]
        },
        {
            id: "collection",
            label: "Saved Collections",
            iconSVG: <CollectionIcon />,
            link: '/collection',
            stateVariables: isDashboard,
            click: function (e: any) {
                setIsDashboard(!isDashboard);
                setIscurrentState('Saved Collections');
                updateIconSidebar(e);
            },
            hasPrivilege: true
        },
        {
            id: "subscription-plans",
            label: "Subscription Plans",
            iconSVG: <WalletIcon />,
            link: '/subscription-plans',
            stateVariables: isDashboard,
            click: function (e: any) {
                setIsDashboard(!isDashboard);
                setIscurrentState('Subscription Plans');
                updateIconSidebar(e);
            },
            hasPrivilege: true
        },
        {
            id: "support",
            label: "Support",
            iconSVG: <SupportIcon />,
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIscurrentState('Support');
                updateIconSidebar(e);
                openMsg91Chat();
            },
            hasPrivilege: true
        }
        // {
        //     id: "users",
        //     label: "Users",
        //     icon: "bx bxs-user",
        //     iconSVG: <UserIcon />,
        //     link: "/user",
        //     stateVariables: isDashboard,
        //     click: function (e: any) {
        //         e.preventDefault();
        //         setIsDashboard(!isDashboard);
        //         setIscurrentState('Users');
        //         updateIconSidebar(e);
        //     },
        //     hasPrivilege: hasPrivilege(PRIVILEGE.AGENCY.USER.INDEX)
        // },
        // {






    ];
    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;